define(function (require) {
    var $ = require("jquery");
    var geocoder = require("@modules/tools/geocoder");
    var utility = require("@modules/tools/helpfulToolUtility");
    var apiUrl = window.scan && window.scan.apiUrl ? window.scan.apiUrl : "";

    var mapper;

    return {
        /**
         * Returns a jQuery promise for the provider search results.
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with CurrentResults array, TotalResults integer, Facets array.
         */
        getResults: function (parameters) {
            return geocoder.geocode(parameters.zipOrAddress).then(function (coordinates) {
                if (!coordinates && parameters.zipOrAddress) {
                    var deferred = $.Deferred();
                    deferred.resolve({
                        TotalResults: 0,
                        CurrentResults: [],
                        Facets: {
                            Gender: [],
                            Language: [],
                            Group: [],
                            NewGroupName: [],
                            Radius: utility.mapFacets(window.scan.emptyRadiusOptions)
                        }
                    });
                    return deferred.promise();
                }

                if (coordinates) {
                    parameters.latitude = coordinates.lat;
                    parameters.longitude = coordinates.lng;
                    parameters.county = coordinates.county;
                }

                // http://scanhealthplan-sc9.resultsbuilderstage.com/api/providersearch/results?year=2018&zipOrAddress=92879&name=&radius=5&gender=&acceptingNewPatientsOnly=false&villageHealthOnly=false&pageNumber=1&pageSize=20&facetsOnly=false&latitude=33.8813831&longitude=-117.5378439
                return $.getJSON(apiUrl + "/api/PractitionerSearch/results", parameters).then(function (results) {
                    // we need to return the lat/lng of the point we searched against, if any.
                    if (results != null) {
                        if (coordinates) {
                            results.latitude = coordinates.lat;
                            results.longitude = coordinates.lng;
                            results.county = coordinates.county;
                        }

                        if (results.Facets["SPECIALTY"]) {
                            results.Facets.SPECIALTY = utility.mapFacets(results.Facets["SPECIALTY"]);
                        }
                        if (results.Facets["PANELSTATUS"]) {
                            results.Facets.PANELSTATUS = utility.mapFacets(results.Facets["PANELSTATUS"]);
                        }
                        if (results.Facets["GROUP"]) {
                            results.Facets.GROUP = utility.mapFacets(results.Facets["GROUP"]);
                        }
                        if (results.Facets["PRODUCT"]) {
                            results.Facets.PRODUCT = utility.mapFacets(results.Facets["PRODUCT"]);
                        }
                        if (results.Facets["GENDER"]) {
                            results.Facets.GENDER = utility.mapFacets(results.Facets["GENDER"]);
                        }
                        if (results.Facets["LANGUAGE"]) {
                            results.Facets.LANGUAGE = utility.mapFacets(results.Facets["LANGUAGE"]);
                        }
                        if (results.Facets["DEGREE"]) {
                            results.Facets.DEGREE = utility.mapFacets(results.Facets["DEGREE"]);
                        }
                        if (results.Facets["FACILITY"]) {
                            results.Facets.FACILITY = utility.mapFacets(results.Facets["FACILITY"]);
                        }
                        if (results.Facets["NEWGROUPNAME"]) {
                            results.Facets.NEWGROUPNAME = utility.mapFacets(results.Facets["NEWGROUPNAME"]);
                        }

                        mapper = window.scan.panelStatusCodeMap;

                    }
                    return results;
                });
            });
        }
    };
});
